import { Button } from '../../../components/ui/button';
import { Plus, Edit, Trash2, HelpCircle } from 'lucide-react';

const FAQ_CATEGORIES = [
  { value: 'general', label: 'General Questions', icon: '❓' },
  { value: 'booking', label: 'Booking & Services', icon: '📅' },
  { value: 'payment', label: 'Payments & Billing', icon: '💳' },
  { value: 'provider', label: 'For Service Providers', icon: '🔧' }
];

export default function CMSFAQsTab({ 
  faqs, 
  onAdd, 
  onEdit, 
  onDelete 
}) {
  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="font-bold text-slate-900 font-[Poppins]">Frequently Asked Questions</h3>
          <p className="text-sm text-slate-500">Help customers find answers quickly</p>
        </div>
        <Button 
          onClick={onAdd}
          className="bg-amber-500 hover:bg-amber-600 text-slate-900"
          data-testid="add-faq-btn"
        >
          <Plus className="w-4 h-4 mr-2" />
          Add FAQ
        </Button>
      </div>
      
      <div className="space-y-6">
        {FAQ_CATEGORIES.map((category) => {
          const categoryFaqs = faqs.filter(f => f.category === category.value);
          
          return (
            <div key={category.value}>
              <h4 className="flex items-center gap-2 text-sm font-medium text-slate-700 mb-3">
                <span>{category.icon}</span>
                {category.label}
                <span className="text-slate-400">({categoryFaqs.length})</span>
              </h4>
              {categoryFaqs.length === 0 ? (
                <p className="text-sm text-slate-400 italic pl-6">No FAQs in this category</p>
              ) : (
                <div className="space-y-2">
                  {categoryFaqs.map((faq) => (
                    <div key={faq.id} className={`p-4 border rounded-xl ${faq.is_active ? 'border-stone-200' : 'border-stone-100 bg-stone-50 opacity-60'}`}>
                      <div className="flex items-start justify-between">
                        <div className="flex-1">
                          <p className="font-medium text-slate-900">{faq.question}</p>
                          <p className="text-sm text-slate-600 mt-1">{faq.answer}</p>
                        </div>
                        <div className="flex gap-1 ml-4">
                          <Button variant="ghost" size="sm" onClick={() => onEdit(faq)}>
                            <Edit className="w-4 h-4" />
                          </Button>
                          <Button variant="ghost" size="sm" className="text-red-500" onClick={() => onDelete(faq.id)}>
                            <Trash2 className="w-4 h-4" />
                          </Button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export { FAQ_CATEGORIES };
